// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"1fccff60a8aeaae1b890","500":"a94787f1b3924f354fe5"}[chunkId] + ".bundle.js";
};